import { RotateCw } from "lucide-react"

import { Button } from "@/components/ui/Button"

export type SystemMessageType = "info" | "error"

export interface SystemMessage {
  message: string
  handleAction?: () => void
  actionText?: string
  type: SystemMessageType
}

interface Props {
  systemMessage: SystemMessage
  isDisabled?: boolean
}

export function ChatSystemMessage({
  systemMessage,
  isDisabled = false,
}: Props) {
  const isError = systemMessage.type === "error"
  const bgColor = isError ? "tw-bg-red-50" : "tw-bg-blue-50"
  const borderColor = isError ? "tw-border-red-700" : "tw-border-blue-700"
  const textColor = isError ? "tw-text-red-800" : "tw-text-blue-800"

  return (
    <div
      className={`tw-flex tw-items-center tw-justify-between tw-py-2 tw-px-3 tw-m-1 tw-mx-4 tw-rounded-lg ${bgColor} tw-border ${borderColor}`}
    >
      <span className={`${textColor} tw-text-sm`}>{systemMessage.message}</span>
      {systemMessage.handleAction && (
        <Button
          variant={isError ? "destructive" : "secondary"}
          size="sm"
          onClick={systemMessage.handleAction}
          disabled={isDisabled}
          title={
            isDisabled
              ? "This action is not available when viewing student work, but it is available for the student."
              : undefined
          }
        >
          <RotateCw />
          {systemMessage.actionText}
        </Button>
      )}
    </div>
  )
}
